import { FaReact } from 'react-icons/fa';
import { useAuth } from '../../../hooks/useAuth.ts';
import { useCustomState } from '../../../hooks/useCustomState.ts';
import { useAccountApplications } from '../../accounts-management';
import { useEffect } from 'react';
import { useUserAccount } from '../../../hooks/useUserAccount.ts';

export const useDashboard = () => {
    const { userAccount } = useUserAccount();

    if (!userAccount) {
        throw new Error('User account is not defined');
    }

    const {
        visibleItems: accountApplications,
        loading,
        fetchRecords,
    } = useAccountApplications(userAccount.id);

    useEffect(() => {
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { idToken, accessToken } = useAuth();
    const { customState, clearCustomState } = useCustomState();

    const applications = accountApplications
        .map((item) => item.application)
        .filter((app): app is NonNullable<typeof app> => app != null);

    const collection = applications.map((item) => ({
        app: item.name ?? '',
        description: item.description ?? '',
        locationOriginal:
            item.url +
            `#id_token=${idToken}&access_token=${accessToken}&token_type=Bearer&expires_in=3600&state=${customState}`,
        location: item.url + '?next=authn',
        logo: item.logoUrl ? item.logoUrl : '',
        icon: <FaReact />,
        onClick: () => {
            clearCustomState();
        },
    }));

    return {
        applications: collection,
        loading,
    };
};
